import { useNavigate } from 'react-router'
import styles from './GoBackButton.module.css'
import { ArrowLeft } from 'lucide-react'

export default function GoBackButton() {
    const navigate = useNavigate()

    return (
    <div  onClick={() => {navigate(-1)}} className={styles.button}>
        <ArrowLeft />
    </div>
  )
}
